export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives3.e4cb90f1.jpg";